import { useState } from "react";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "@/components/modals/BaseModal";
import { cerrarFase } from "@/ts/api/API";
import { notificacionError } from "@/components/Alerts";
import { Constantes } from "@/ts/constantes";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { tsToInput } from "@/ts/util";
import { updateCacheOF } from "@/hooks/Api/OrdenesFabricacion";

interface CerrarFaseProps extends BaseModalProps {
	readonly idOF: number | null;
	readonly idFase: number | null;
}
export function ModalCerrarFase(props: CerrarFaseProps) {
	const [fecha, setFecha] = useState(() => Math.trunc(Date.now() / 1000));

	const cerrarMutation = useCerrarMutation(props);


	const cerrar = () => {
		const date = new Date(fecha);
		const timestampCierre = Math.trunc(date.getTime() / 1000);
		const { idOF, idFase } = props;

		if (isNaN(timestampCierre)) {
			notificacionError("Fecha no válida");
			return;
		}

		if (idOF == null || idFase == null) {
			notificacionError("ID de OF o Fase no válido");
			return;
		}

		cerrarMutation.mutate({
			idOF, idFase,
			fechaCierre: timestampCierre,
		});
	};

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h2 className="modal-title">
					<span>Cerrar Fase:</span>
					<span>OF #{props.idOF}</span>
					{Constantes.existenFases ? (
						<span>- Fase {props.idFase}</span>
					) : null}
				</h2>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				<div className="content-box big-box">
					<div className="containerLbl">
						<label className="labelsForm" htmlFor="inputFechaFase">Fecha</label>
						<input className="inputsForm" id="inputFechaFase" type="date" value={tsToInput(fecha)} onChange={(event) => { setFecha(event.target.valueAsDate!.getTime() / 1000); }} />
					</div>
				</div>
			</div>
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>Cancelar</button>
				<button type="button" className="btnPrimary" onClick={cerrar}>Cerrar Fase</button>
			</div>
		</BaseModal>
	);
}

function useCerrarMutation(props: CerrarFaseProps) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (payload: { idOF: number; idFase: number; fechaCierre: number; }) => {
			return cerrarFase(payload);
		},
		onSuccess: (result) => {
			if (result.status === "error") {
				notificacionError(result.message || "Error al cerrar la fase");
				return;
			}

			void updateCacheOF(props.idOF!, queryClient);
			void queryClient.invalidateQueries({ queryKey: ["getOFsEnCurso"] });

			props.close();
		},

		onError: (error: unknown) => {
			let mensaje = "Error al cerrar la fase";

			if (error instanceof Error) mensaje = error.message;
			else if (typeof error === "string") mensaje = error;
			else if (typeof error === "object" && error !== null && "message" in error)
				mensaje = String(error.message);

			notificacionError(mensaje);
		},
	});
}